import React from 'react';

/** Real-brand avatar palette (no photo field yet — initials fallback). */
const PALETTE = [
  { bg: '#ea580c', ring: '#fed7aa' },
  { bg: '#c2410c', ring: '#ffedd5' },
  { bg: '#57534e', ring: '#d6d3d1' },
  { bg: '#78716c', ring: '#e7e5e4' },
  { bg: '#b45309', ring: '#fde68a' },
  { bg: '#9a3412', ring: '#ffedd5' },
  { bg: '#44403c', ring: '#d6d3d1' },
  { bg: '#d97706', ring: '#fef3c7' },
];

function hashSeed(seed) {
  const s = String(seed || '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function getClientInitials(name, phone) {
  const n = String(name || '').trim();
  if (n) {
    const parts = n.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    }
    return n.slice(0, 2).toUpperCase();
  }
  const digits = String(phone || '').replace(/\D/g, '');
  return digits.slice(-2) || '?';
}

/**
 * Initials avatar for clients (photo upload can plug into `photoUrl` later).
 */
export default function ClientAvatar({
  name,
  phone,
  seed,
  photoUrl,
  size = 40,
  radius = 12,
  style,
}) {
  const palette = PALETTE[hashSeed(seed || name || phone) % PALETTE.length];
  const initials = getClientInitials(name, phone);
  const fontSize = size >= 56 ? '1.15rem' : size >= 44 ? '0.95rem' : '0.8rem';

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name || ''}
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          objectFit: 'cover',
          border: `2px solid ${palette.ring}`,
          flexShrink: 0,
          ...style,
        }}
      />
    );
  }

  return (
    <div
      aria-hidden
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: palette.bg,
        border: `2px solid ${palette.ring}`,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize,
        letterSpacing: '0.02em',
        flexShrink: 0,
        userSelect: 'none',
        ...style,
      }}
    >
      {initials}
    </div>
  );
}
